import React from 'react'
import ReactMarkdown from 'react-markdown'
import styles from './styles.css'
import { Hero as Props } from '../schema'
import Map from '../Map'

const Hero: React.SFC<Props> = ({ image, title, titleColor, details, heroBody, location }) => {
  const heroTextColor = titleColor ? titleColor : '#ffffff'

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.banner}
        style={{ backgroundImage: `url(${image.imageUrl}?h=400&fit=fill)` }}
      >
        <div className={styles.title} style={{ color: heroTextColor }}>
          {title}
        </div>
        <div className={styles.details} style={{ color: heroTextColor }}>
          {details}
        </div>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.meanContent}>
          <div className={styles.heroBody}>
            <ReactMarkdown source={heroBody} />
          </div>
        </div>
        {location && (
          <div className={styles.mapContainer}>
            <Map location={location} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Hero
